import { numMul, numSub } from "common/utils/nominalNumbers";
import { inches } from "doc/pdf/drawingLayout";
import { MARGIN_INCHES, MARGIN_LEFT_INCHES, PAGE_HEIGHT_INCHES, PAGE_WIDTH_INCHES } from "doc/plans/constants";
import type { OrientationInfo } from "lib/house/plans/planPagesTypes";

export function getRenderSizeWithTitleBlock(): OrientationInfo {
  return {
    renderWidth: numSub(numSub(numSub(PAGE_WIDTH_INCHES, MARGIN_LEFT_INCHES), MARGIN_INCHES), inches(3.5)),
    renderHeight: numSub(PAGE_HEIGHT_INCHES, numMul(MARGIN_INCHES, 2)),
  };
}
